import React from "react"
import tw, { styled } from "twin.macro"

const Container = styled.div`
  ${tw`
    transition-[padding] duration-300
    mx-auto px-4 sm:px-8 xl:px-16
    max-w-[95rem]
    // md:max-w-3xl lg:max-w-5xl xl:max-w-7xl 2xl:max-w-[90rem]
  `}
`

// need the className prop to be able to style this component using twin in other components
const DynamicContainer = ({ children, className }) => {
  return <Container className={className}>{children}</Container>
}

export default DynamicContainer
